import { createStore, compose, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import rootReducers from '../reducers';
import sagas from '../sagas';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
//import AsyncStorage from '@react-native-community/async-storage';
//import currentScreenReducer from '../reducers/currentScreenReducer';

const config = {
  key: 'app',
  storage: storage,
  //whitelist: ['signupReducer'],
  //stateRecondiler: autoMergeLevel2,
  debug: false //to get useful logging
};

const middleware = [];
const sagaMiddleware = createSagaMiddleware();

middleware.push(sagaMiddleware);

//if (__DEV__) {
middleware.push(createLogger({ duration: true }));
//}
const reducers = persistCombineReducers(config, rootReducers);
const enhancers = [applyMiddleware(...middleware)];

const persistConfig = { enhancers };
//const rootReducer = combineReducers({ currentscreen: currentScreenReducer });
const store = createStore(reducers, undefined, compose(...enhancers));
const persistor = persistStore(store, persistConfig, () => {});
const configureStore = () => {
  return { persistor, store };
};

sagaMiddleware.run(sagas);

export default configureStore;
